import type {
  CategoryCreateDto,
  CategoryResponseDto,
  CategoryTreeDto,
  CategoryUpdateDto,
} from "@/types/category.dto";
import type { ApiResponse, PagedResponseDto } from "@/types/common";
import { apiClient, unwrapApiResponse } from "./httpClient";

export const categoriesService = {
  getTree(): Promise<CategoryTreeDto[]> {
    return unwrapApiResponse(apiClient.get<ApiResponse<CategoryTreeDto[]>>("/Categories/tree"));
  },

  getRoot(): Promise<CategoryResponseDto[]> {
    return unwrapApiResponse(apiClient.get<ApiResponse<CategoryResponseDto[]>>("/Categories/root"));
  },

  getById(id: number): Promise<CategoryResponseDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<CategoryResponseDto>>(`/Categories/${id}`));
  },

  getAll(page = 1, pageSize = 50, activeOnly = true): Promise<PagedResponseDto<CategoryResponseDto>> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<PagedResponseDto<CategoryResponseDto>>>("/Categories", {
        params: { page, pageSize, activeOnly },
      }),
    );
  },

  create(dto: CategoryCreateDto): Promise<CategoryResponseDto> {
    return unwrapApiResponse(apiClient.post<ApiResponse<CategoryResponseDto>>("/Categories", dto));
  },

  update(id: number, dto: CategoryUpdateDto): Promise<CategoryResponseDto> {
    return unwrapApiResponse(apiClient.put<ApiResponse<CategoryResponseDto>>(`/Categories/${id}`, dto));
  },

  delete(id: number): Promise<boolean> {
    return unwrapApiResponse(apiClient.delete<ApiResponse<boolean>>(`/Categories/${id}`));
  },
};
